var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoundCheck = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12px",
  height: "12px",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "round_Check") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-69.000000, -699.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "round_Check",
  transform: "translate(69.000000, 699.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 12,
  height: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,1 C3.25,1 1,3.25 1,6 C1,8.75 3.25,11 6,11 C8.75,11 11,8.75 11,6 C11,3.25 8.75,1 6,1 M5,8.5 L2.5,6 L3.205,5.295 L5,7.085 L8.795,3.29 L9.5,4 L5,8.5 Z",
  id: "Shape",
  fill: "#424242",
  fillRule: "nonzero"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoundCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/round_Check.ec7f0704237af7866c63e0ed3de5986c.svg";